<template>
    <component :is="dynamicLayout"/>
</template>
<script>
	import {mapActions, mapState, mapMutations} from 'vuex';
	import isEmpty from 'lodash/isEmpty';

	import SimpleLayout from '@/layouts/SimpleLayout.vue'
	import DefaultLayout from '@/layouts/Default.vue'
	import LandingPageLayout from "@/layouts/LandingPageLayout";

	export default {
		components: {
			DefaultLayout,
			SimpleLayout,
			LandingPageLayout
		},
		data() {
			return {
				layout: "SimpleLayout"
			}
		},
		computed: {
			...mapState([
				'selectedDate'
			]),
			dynamicLayout: {
				get() {
					return this.layout
				},
				set(newLayout) {
					this.layout = newLayout
				}
			},
			isValidToFetchSummary() {
				return !isEmpty(this.$route.params) && ['sentiment', 'mention', 'postdetail', 'audience', 'platform', 'comparison', 'edit-monitor'].includes(this.$route.name);
			}
		},
		watch: {
			$route: {
				handler(to, from) {
					to.matched.some(record => {
						this.dynamicLayout = record.meta.layout
					});
					if (this.isValidToFetchSummary && (to.params.monitor_uuid !== from.params.monitor_uuid)) {
						let{monitor_uuid} = to.params;
						this.setSummaryReady(false);
						this.setReady(false);
						Promise.all([
							this.fetchFacebookSummary({
								monitor_uuid: monitor_uuid,
								timerange: this.selectedDate
							}),
							this.fetchMonitor({monitor_uuid: monitor_uuid}),
                            this.fetchMonitorFanCount({monitor_uuid: monitor_uuid})
						])
							.then(_ => {
								this.setSummaryReady(true);
								this.setReady(true);
							});
					}
				},
			}
		},
		methods: {
			...mapMutations('monitors', [
				"setReady"
			]),
			...mapMutations('mention', [
				'setSummaryReady'
			]),
			...mapActions('mention', [
				"fetchMonitorFanCount"
			]),
			...mapActions([
				'fetchFacebookSummary',
				'fetchMonitor'
			]),
		}
	}
</script>
<style>
    :root{
        --bindez-green-color: #29A689;
        --bindez-light-grey-color: #bababa;
        --bindez-medium-grey-color: #AFBAC8;
        --bindez-dark-grey-color: #627781;
    }

    .description--color{
        color: var(--bindez-medium-grey-color);
    }

    .monitor-title--color {
        color: var(--bindez-green-color);
    }

    .section-title--color {
        color: var(--bindez-dark-grey-color);
    }

    .toolbar-title--color{
        color: var(--bindez-dark-grey-color);
    }

    .watch {
        color: var(--bindez-green-color);
    }

    .downloadable-card-header{
        display: flex;
        justify-content: space-between;
    }


    @font-face {
        font-family: "Zawgyi-One";
        src: url("../public/fonts/zawgyi.woff");
    }

    .list__item-bottom-seperator {
        border-bottom: 1px solid #f5f5f5;
    }

    .zawgyi {
        font-family: "Zawgyi-One"
    }

    .v-input--selection-controls.my__custom__class .v-input__slot {
        margin-bottom: 0;
    }

    .keyword-add-input--color {
        color: #bababa;
    }

    .v-text-field.v-text-field--solo .v-input__control {
        min-height: 25px;
    }

    .search-box--height.v-text-field.v-text-field--solo .v-input__control {
        min-height: 25px;
    }

    .app-compo-selector.v-select.v-text-field--solo .v-input__slot {
        min-height: 25px;
    }

    .custom-box.v-text-field.v-text-field--outline .v-input__slot {
        border: 1px solid #cecece !important;
    }

    .custom-checkbox-size i {
        font-size: 18px !important;
        display: flex;
    }

    .custom-radio-size i {
        font-size: 18px !important;
        display: flex;
    }

    .nav-active-color .v-list__group.v-list__group--active .v-list__group__header {
        background: rgba(255, 255, 255, 0.10);
    }

    .nav-active-color .v-list__tile--active {
        color: #fff !important;
    }

    .tabs-active {
        border-bottom: 2px solid var(--bindez-green-color);
    }

    .add-cursor {
        cursor: pointer;
    }
    /*chip styles*/

    .pointer-wait {
        cursor: no-drop;
    }

    .tags_highlight {
        color: var(--bindez-green-color) !important;
        border-color: var(--bindez-green-color) !important;
    }

    .chip-wrapper .chip--custom-margin{
        margin: 4px 8px 4px 0;
    }

    .divider-custom--width{
        width: 95%;
        margin: 0 auto;
    }

</style>
